module.exports = __webpack_public_path__ + "static/img/logout.5a5dbd6a.svg";